import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { VariantService } from './variant.service';

@Injectable({
  providedIn: 'root'
})
export class VariantAuditService {
  constructor(
    private api: ApiService,
    private router: Router,
    private variantService: VariantService
  ) {}

  startTracking(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const path = event.urlAfterRedirects || event.url;
        this.logPageView$(path).pipe(catchError(() => EMPTY)).subscribe();
      });
  }

  private logPageView$(url: string) {
    const sessionUuid = this.variantService.getSessionUuid();
    const payload = {
      session_uuid: sessionUuid,
      event_type: 'page_view',
      page_url: window.location.href,
      page_path: url,
      referrer: document.referrer || null,
      ip_address: null,
      user_agent: navigator.userAgent,
      browser_info: this.getBrowserInfo()
    };
    return this.api.dispatch('/variants/audit', payload);
  }

  logCustomEvent(eventType: string, pageUrl?: string, pagePath?: string): void {
    try {
      const sessionUuid = this.variantService.getSessionUuid();
      
      const payload = {
        session_uuid: sessionUuid,
        event_type: eventType,
        page_url: pageUrl || window.location.href,
        page_path: pagePath || window.location.pathname,
        referrer: document.referrer || null,
        ip_address: null,
        user_agent: navigator.userAgent,
        browser_info: this.getBrowserInfo()
      };

      this.api.dispatch('/variants/audit', payload).pipe(catchError(() => EMPTY)).subscribe();
    } catch (error) {
      console.warn('Error logging custom event:', error);
    }
  }

  private getBrowserInfo(): any {
    try {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      };
    } catch {
      return {};
    }
  }
}

